<!--
 * @Author: zhai
 * @Description: 主申人
-->
<template>
    <div>
        <div class="box-title">
            <span>主申请人</span>
            <div class="title-btn">
                <el-button v-if="!isEdit" type="primary" @click="editInfo()">编辑</el-button>
                <el-button v-if="isEdit" @click="cancel">取消</el-button>
                <el-button v-if="isEdit" :loading="isLoading" type="primary" @click="saveSuccess()">保存</el-button>
            </div>
        </div>
        <!-- 回显信息 -->
        <ApplicantDetail v-if="!isEdit" :data="data" class="pl-15 pr-15"/>
        <!-- 编辑 -->
        <ApplicantEdit ref="editForm" v-loading="isLoading" v-if="isEdit" :data="data" />
    </div>
</template>

<script>
import ApplicantDetail from './C/ApplicantDetail.vue'
import ApplicantEdit from './C/ApplicantEdit.vue'
import { postClientInfo } from '../../../../../../api/gifted'
export default {
    props: {
        data: {
            type: Object,
            default:() => {}
        },
    },
    components: {
        ApplicantDetail,
        ApplicantEdit
    },
    data() {
        return {
            isEdit: false,
            oldData: {},
            isLoading: false,
        }
    },
    methods: {
        editInfo() {
            this.isEdit = true;
            this.oldData = JSON.parse(JSON.stringify(this.data.applicant))
        },
        // 保存成功
        saveSuccess() {
            const applicantEdit = this.$refs['editForm'].save();
            Promise.all([applicantEdit]).then(() => {
                //全部验证通过就会走这里
                this.postClientInfo()
            }, err => {
                this.$utils.scrollIntoError(this);
            })
        },
        async postClientInfo() {
            this.isLoading = true;
            try {
                const { code } = await postClientInfo(this.data)
                if (code === 200) {
                    this.$message.success("保存成功！");
                    this.isEdit = false;
                }
            } finally {
                this.isLoading = false
            }
        },
        cancel() {
            this.data.applicant = JSON.parse(JSON.stringify(this.oldData));
            this.isEdit = false;
        }
    }
}
</script>

<style lang="less" scoped>
.box-title {
    padding: 8px 15px;
    background: #f2f2f2;
    color: #000;
    display: flex;
    align-items: center;
    span {
        flex: 1;
        font-weight: bold;
    }
    .title-btn {
        float: left;
    }
}
</style>